























import Vue from 'vue';
import Component from 'vue-class-component';
import BaseComponent from '@/components/base-component.vue';
import SideMenu from '@/components/home/menu/side-menu.vue';
import UserToolbarMenu from '@/components/home/menu/user-toolbar-menu.vue';
import Footer from '@/components/home/footer.vue';
import PermissionDebug from '@/components/UI/permission-debug.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ClientInfo from '@/components/home/menu/client-info.vue';
import { getServerDateTime } from '../../../services/utils';
import * as UpdateUserData$ from '@/subjects/update-user-data';
import * as resize from '@/subjects/resize'
import NotificationMenu from '@/components/notifications/notification-menu.vue';

@Component({
  components: {
    UserToolbarMenu,
    PermissionDebug,
    PermissionAuth,
    SideMenu,
    Footer,
    ClientInfo,
    NotificationMenu
  },
})
export default class Home extends BaseComponent {
  /**
   * Using null as the starting value for its v-model will initialize the drawer as closed on mobile and as open on desktop. 
   */
  public drawerIsOpen: boolean = null;

  private pronto: boolean = false;

  private beforeMount() {
    let serverTimePronto = false;
    let userDataPronto = false;
    
    this.loader.start();

    this.addSubsc(
      getServerDateTime().subscribe(
        (r) => {
          serverTimePronto = true;
          this.pronto = userDataPronto;
          if (this.pronto) {
            this.loader.stop();
          }
        },
        (error) => {
          userDataPronto = true;
          this.pronto = serverTimePronto;
          if (this.pronto) {
            this.loader.stop();
          }
        },
      ),
    );
    
    UpdateUserData$.update();

    UpdateUserData$.get().subscribe((data) => {
      userDataPronto = true;
      this.pronto = serverTimePronto
      if (this.pronto) {
        this.loader.stop();
      }

    });
  }

  public toggleSideMenu(): void {
    this.drawerIsOpen = !this.drawerIsOpen;
  }

  public onToggleSideMenu(val: boolean): void {
    this.drawerIsOpen = val;
  }

  public onTrocarEmpresa() {    
    let menu:any = this.$refs.userToolbarMenu;
    menu.openModalBusinessUnit();
  }

  
  public onResizeWindow(val) {
    resize.windowSizeChanged$.next(val);
  }
}
